export const VideoTypeYoutube = 'YouTube';
export const VideoTypeWistia = 'Wistia';

export const getVideoType = (url)  => {
  if (url.includes('youtube.com') || url.includes('youtu.be') || url.includes('youtube-nocookie.com')) {
    return VideoTypeYoutube;
  }
  if (url.includes('wistia.com') || url.includes('wi.st')) {
    return VideoTypeWistia;
  }
  return '';
}
